import { Store } from "react-notifications-component";

export const sendNotification = (type, title, message) => {

  try {
    Store.addNotification({
      title,
      message,
      type,
      insert: "top",
      container: "top-right",
      content: () => (
        <div className={`notificationCard ${type}`}>
          <p className="notificationTitle">{title}</p>
          <h5 className="notificationMessg">{message}</h5>
        </div>
      ),
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 4000},
      width: 300
    });
  } catch (e) {
    console.log(e.message);
  }
};